import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";

import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";

const AddOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);

  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [zone, setZone] = useState([]);

  const [formData, setFormData] = useState({
    country_id: "",
    state_id: "",
    city_id: "",
    zone_id: "",
    name: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    if (e.name === "country_id") {
      setFormData({
        ...formData,
        [e.name]: e,
        state_id: "",
        city_id: "",
      });
      getSelectedState(e.value);
    } else if (e.name === "state_id") {
      setFormData({
        ...formData,
        [e.name]: e,
        city_id: "",
      });
      getSelectedCity(e.value);
    } else if (e.name === "city_id") {
      setFormData({
        ...formData,
        [e.name]: e,
      });
    } else if (e.name === "zone_id") {
      setFormData({
        ...formData,
        [e.name]: e,
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = await Validation.FormValidation({
      classname: ".pincodeclass",
    });

    const validationErrorsSelect = Validation.SelectValidation({
      classname: ".pincodeclass",
    });

    if (validationErrors && validationErrorsSelect) {
      try {
        const response = await postData("/masters/pincode", formData);
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  const successStyle = {
    color: "green",
    marginLeft: "5px",
  };

  async function getSelectedState(id) {
    const response = await getData(`/masters/allstate/${id}`);

    if (response.success) {
      setState(response.data);
    }
  }

  async function getSelectedCity(id) {
    const response = await getData(`/masters/allcity/${id}`);

    if (response.success) {
      setCity(response.data);
    }
  }

  const GetAllCountry = async () => {
    const response = await getData("/masters/allcountry");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "country_id",
          label: data.name,
        });
      });
    }
    setCountry(option);
  };

  const GetAllZone = async () => {
    const response = await getData("/masters/zone");
    const option = [];
    if (response.success) {
      response?.data?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "zone_id",
          label: data.name,
        });
      });
    }
    setZone(option);
  };

  useEffect(() => {
    GetAllCountry();
    GetAllZone();
  }, []);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Pincode</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="pincodeclass"
                          >
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={12}>
                                    <div className="main-form-section mt-5">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label column sm={3}>
                                          Select Zone{" "}
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            name="zone_id"
                                            className="input-mandatory"
                                            onChange={(selectedOption) =>
                                              handleChange(selectedOption)
                                            }
                                            value={formData.zone_id}
                                            options={zone}
                                          />

                                          <span className="error-message"></span>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select Country{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="country_id"
                                        className="input-mandatory"
                                        onChange={(selectedOption) =>
                                          handleChange(selectedOption)
                                        }
                                        value={formData.country_id}
                                        options={country}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select State{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="state_id"
                                        className="input-mandatory"
                                        onChange={handleChange}
                                        value={formData.state_id}
                                        options={state.map((stateOption) => ({
                                          value: stateOption.id,
                                          name: "state_id",
                                          label: stateOption.name,
                                        }))}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="row justify-content-center mb-2">
                                    <Form.Label column sm={3}>
                                      Select City{" "}
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Select
                                        name="city_id"
                                        className="input-mandatory"
                                        onChange={handleChange}
                                        value={formData.city_id}
                                        options={city?.map((stateOption) => ({
                                          value: stateOption.id,
                                          name: "city_id",
                                          label: stateOption.name,
                                        }))}
                                      />

                                      <span className="error-message"></span>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col md={6}>
                                <div className="main-form-section mt-5">
                                  <Row className="justify-content-center">
                                    <Form.Label column sm={3}>
                                      Pincode
                                    </Form.Label>
                                    <Col sm={6}>
                                      <Form.Group>
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData?.name}
                                            onChange={handleChange}
                                            placeholder="Pincode "
                                            id="inputEmail3"
                                            maxLength={6}
                                            className="input-mandatory"
                                          />
                                        </InputGroup>
                                        <span className="error-message"></span>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>

                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>
                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit}
                                  />
                                </div>
                              </Row>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
